import { useMyPermissions } from "modules/my-permissions";
import React, { CSSProperties } from "react";
import { api } from "shared/api";
import { useApiMethod } from "shared/lib";
import { Fieldset } from "shared/ui";
import { AvatarInput } from "shared/ui/avatar-input";

export interface ICompanyAvatarForm {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const CompanyAvatarForm = (props: ICompanyAvatarForm) => {
  const company = api.company.useCompanyGet(props.companySlug);
  const submit = useApiMethod(api.company.companyChangeAvatarImage);

  const permissions = useMyPermissions(props.companySlug);

  const updateAvatar = async (value: string | undefined) => {
    if (!company.data?.id) return;
    if (!value) return;

    await submit.call(company.data?.id, { value });
    await company.mutate();
  };

  return (
    <form className={props.className} style={props.style} id={props.htmlId}>
      <Fieldset disabled={!permissions?.company.general.update}>
        <Fieldset.Content>
          <AvatarInput
            id={company.data?.id!}
            name={company.data?.name!}
            value={company.data?.avatarImage?.id}
            onChange={updateAvatar}
            style={{ float: "right" }}
            tabIndex={-1}
          />
          <Fieldset.Title>Аватар</Fieldset.Title>
          <Fieldset.Subtitle>
            Нажмите на него, чтобы загрузить файлы.
            <br />
            Также вы можете{" "}
            <a onClick={() => updateAvatar(undefined)} tabIndex={-1}>
              удалить
            </a>{" "}
            аватар.
          </Fieldset.Subtitle>
        </Fieldset.Content>
        <Fieldset.Footer>
          <Fieldset.Footer.Status>
            {!submit.error && <>Аватар опционален, но рекомендуется его установить</>}
            {submit.error && <Fieldset.Error>{submit.error.message}</Fieldset.Error>}
          </Fieldset.Footer.Status>
        </Fieldset.Footer>
      </Fieldset>
    </form>
  );
};

CompanyAvatarForm.defaultProps = {};
